import { ListaContactoModeloMSL } from './../../../open-api/model/listaContactoModeloMSL';
import { UserModel } from 'src/app/core/models/user.model';
import { ListarContactosUsuarioME } from './../../../open-api/model/listarContactosUsuarioME';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactoService } from './../../../open-api/api/contacto.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EMPTY_STRING } from 'src/app/shared/utils/regular-expresions';

@Component({
  selector: 'app-contactos-modal',
  templateUrl: './contactos-modal.component.html',
  styleUrls: ['./contactos-modal.component.scss'],
})
export class ContactosModalComponent implements OnInit {
  @Input() esInterno?: boolean;
  usuario?: UserModel;
  contactos: ListaContactoModeloMSL[] = [];
  contactosFind: ListaContactoModeloMSL[] = [];
  contacto?: ListaContactoModeloMSL;
  searchForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private contactoService: ContactoService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {
    this.searchForm = this.fb.group({
      nombre: [null],
    });
  }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    this.authService.user.subscribe((usuario) => {
      this.usuario = usuario;
    });
    await this.ObtenerContactos();
    this.spinner.hide();
  }

  async ObtenerContactos(): Promise<void> {
    const parametro: ListarContactosUsuarioME = {
      esInterno: this.esInterno,
      usuarioId: this.usuario?.id,
    };

    await this.contactoService
      .apiV10ContactoListarContactosUsuarioPost(parametro)
      .toPromise()
      .then((contactos) => {
        this.contactos =
          contactos?.lista?.filter(
            (item) => item.esInterno == this.esInterno
          ) || [];
      });
  }

  SeleccionarContacto(contacto: ListaContactoModeloMSL): void {
    this.contacto = contacto;
  }

  CerrarModal(): void {
    this.activeModal.close(this.contacto);
  }


  async BuscarContacto() {
    this.spinner.show();
    const identificacion = this.searchForm
      .get('nombre')
      ?.value?.toLowerCase()
      .trim();
  
    if (!identificacion) {
      this.spinner.hide();
      return;
    }
    this.contactosFind = [...this.contactos];
    this.contactos = this.contactosFind.filter((c) =>
      c.contactoNombre?.toLowerCase().includes(identificacion) ||
      c.numeroCuenta?.toLowerCase().includes(identificacion)
    );
  
    this.spinner.hide();
  }
  

  async limpiarCampo() {
    this.searchForm.get('nombre')?.setValue(EMPTY_STRING);
    this.ObtenerContactos();
  }
}
